import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";

const items = [
  {
    quote:
      "Гениальная артистка и гениальные люди, кто создал и принимал участие в этом проекте. Рекомендую всем!!!",
    author: "ЯНДЕКС АФИША",
    role: "МОСКВА",
  },
  {
    quote:
      'Еще один новый иммерсивный опыт - "Вечные. Шопен." в гастротеатре "Наблюдатель" - чистый восторг!!!',
    author: "ЯНДЕКС АФИША",
    role: "МОСКВА",
  },
  {
    quote:
      "Через музыку услышала свою душу 🙏 Очень понравилось. Формат прекрасный ужин с театром — отличный вечер",
    author: "ЯНДЕКС АФИША",
    role: "МОСКВА",
  },
  {
    quote:
      "Сегодня уже в третий раз посетила этот прекрасный моноспектакль. Сказать, что я в восторге - это ничего не сказать!",
    author: "ЯНДЕКС АФИША",
    role: "МОСКВА",
  },
];

export default function Testimonials() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(
      () => setIdx((v) => (v + 1) % items.length),
      7000
    );
    return () => clearInterval(t);
  }, []);

  const next = () => setIdx((v) => (v + 1) % items.length);
  const prev = () => setIdx((v) => (v - 1 + items.length) % items.length);
  const current = items[idx];

  return (
    <section
      className="relative py-16 lg:py-24 overflow-hidden"
      data-testid="testimonials-section"
    >
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at center, rgba(229,115,36,0.08) 0%, rgba(8,6,5,0) 60%)",
        }}
      />
      <div className="container-custom relative">
        <div className="eyebrow mb-8 text-center">· Что говорит публика</div>

        <div className="relative min-h-[340px] flex flex-col items-center justify-center">
          <Quote
            size={56}
            className="mb-8 opacity-40"
            style={{ color: "#E57324" }}
          />
          <AnimatePresence mode="wait">
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.7 }}
              className="max-w-4xl text-center"
              data-testid={`testimonial-${idx}`}
            >
              <p
                className="font-serif italic font-light leading-[1.2] text-[#F2E9DE]"
                style={{ fontSize: "clamp(1.4rem, 3vw, 2.4rem)" }}
              >
                «{current.quote}»
              </p>
              <div className="mt-10">
                <div className="text-sm tracking-[0.2em] uppercase text-[#E57324]">
                  {current.author}
                </div>
                <div className="text-xs tracking-[0.2em] uppercase text-[#A99F96] mt-1">
                  {current.role}
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8">
          <button
            onClick={prev}
            data-testid="testimonial-prev"
            className="text-[#A99F96] hover:text-[#E57324] transition-colors"
            aria-label="prev"
          >
            <ChevronLeft size={28} />
          </button>
          <div className="flex items-center gap-2">
            {items.map((_, i) => (
              <button
                key={i}
                onClick={() => setIdx(i)}
                data-testid={`testimonial-dot-${i}`}
                className="h-[2px] transition-all"
                style={{
                  width: i === idx ? 32 : 16,
                  background: i === idx ? "#E57324" : "#A99F96",
                  opacity: i === idx ? 1 : 0.4,
                }}
                aria-label={`go to ${i}`}
              />
            ))}
          </div>
          <button
            onClick={next}
            data-testid="testimonial-next"
            className="text-[#A99F96] hover:text-[#E57324] transition-colors"
            aria-label="next"
          >
            <ChevronRight size={28} />
          </button>
        </div>
      </div>
    </section>
  );
}
